import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import _ from "lodash";

Vue.use(Vuex);

const defaultProfile = {
    id: '',
    userName: '',
    loginId: '',
    loginPw: '',
    loginCompCd: '',
    token: '',
    authorities: [],
    menus: [],
    programList: [],
    asAgentId : '',
    groupUId : '',
    isAdmin: false ,
    isSearchAll: false //전체 조회 권한
}

export default new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        loginInfo: {
            id: '',
            userName: '',
            loginId: '',
            loginPw: '',
            loginCompCd: '',
            token: '',
            authorities: [],
            programList: [],
            menus: [],
            asAgentId : '',
            groupUId : '',
            isAdmin: false ,
            isSearchAll: false //전체 조회 권한
        },
        locale: "ko",
        isLoading: false,
        oauthNew: '',
        board:{
            title:'',
            boardCd:'',
            boardId:'',
            refresh: false,
        },
        popList:[], //소식지 팝업 여러개
        headerComponentName: undefined,
        routeName: undefined,
        referrer: undefined,
        isMobile: false,
    },
    mutations: {
        login(state, loginInfo) {
            //state.loginInfo = loginInfo;
            state.loginInfo = _.merge({}, defaultProfile, loginInfo || {});
        },
        logout(state) {
            //state.loginInfo = null;
            state.loginInfo = Object.assign(defaultProfile);
            //state.popList=[]
        },
        loading(state) {
            state.isLoading = true;
        },
        finish(state) {
            state.isLoading = false;
        },
        register(state, oauthNew) {
            state.oauthNew = oauthNew;
        },
        setLocale(state, locale) {
            state.locale = locale;
        },
        boardCd(state, boardInfo){
            state.board = boardInfo
        },
        //소식지 팝업 여러개
        popLists(state, popInfo){
            for(let i=0; i<state.popList.length; i++){
                if(state.popList[i].id == popInfo.id){
                    state.popList.splice(i,1)
                }
            }
            state.popList.push(popInfo)
        },
        /**
         * 헤더 타이틀 셋팅
         *
         * @param {State} state
         * @param {object} object
         */
        setHeaderTitle(state, object) {
            object = _.merge(
            {
                headerComponentName: undefined,
                routeName: undefined,
                referrer: undefined,
                isMobile: false,
            },
            object || {}
            );
    
            state.headerComponentName = object.headerComponentName;
            state.routeName = object.routeName || state.routeName;
            state.referrer = object.referrer;
            state.isMobile = object.isMobile;
            
            document.title = state.routeName;
        },
        /**
         * router name 변경
         *
         * @param {State} state
         * @param {object} object
         */
        changeRouterName(state, value) {
            state.routeName = value || "";
        },
        
        setBoardRefresh(state, value){
            state.board.refresh = value || false;
        },
    },
});
